import React from "react";
import styles from "./TableLoader.module.scss";

export default function TableLoader({ noOftd }) {
  const rows = Array.from({ length: 5 }, (_, index) => (
    <tr key={index} className={styles.animated_tr}>
      {Array.from({ length: noOftd }, (__, columnIndex) => (
        <td key={columnIndex}></td>
      ))}
    </tr>
  ));

  return <tbody>{rows}</tbody>;
}
